import { FC, useCallback, useEffect, useState } from 'react'
import { withRouter } from 'react-router'

import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'


type Props = {
  when: boolean
  message: string | ((location: { pathname: string }) => string | boolean)
  router: any
  route: {
    path: string
    __id__: number
  }
}

const PromptRouter3Custom = ({ when, message: getMessage, router, route }: Props) => {
  const [message, setMessage] = useState('')
  const [nextLocation, setNextLocation] = useState<null | string>(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)

  const handleCancel = useCallback(() => {
    setMessage('')
  }, [setMessage])

  const handleConfirm = useCallback(() => {
    setMessage('')
    setConfirmedNavigation(true)
  }, [])

  const routerWillLeave = useCallback((location: { pathname: string }) => {
    const { pathname } = location
    if (!confirmedNavigation) {
      if (when) {
        const messageRes = typeof getMessage === 'function' ? getMessage(location) : getMessage
        if (typeof messageRes === 'boolean') return messageRes
        setMessage(messageRes)
        setNextLocation(pathname)
        return false
      }
    }
    return true
  }, [confirmedNavigation, when, getMessage])

  useEffect(() => {
    router.setRouteLeaveHook(route, routerWillLeave)
  }, [router, route, routerWillLeave])

  useEffect(() => {
    if (confirmedNavigation && nextLocation) {
      router.push(nextLocation)
    }
  }, [confirmedNavigation, nextLocation]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    message
      && <PlainConfirmModal
        messageText={message}
        cancelButtonTitle="Нет"
        confirmButtonTitle="Да"
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
  )
}

const PromptRouter3CustomWithRouter: FC<Omit<Props, 'router'>> = withRouter(PromptRouter3Custom)

export default PromptRouter3CustomWithRouter
